<div class="modal-header">
  <div class="col-1"></div>
  <div class="col-10">
    <h4 class="modal-title text-center" id="modal-basic-title">Create New Reminder</h4>
   </div>
  <div class="col-1">
    <button type="button" class="close" aria-label="Close" (click)="dismiss()" data-testid="new-reminder-modal-close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  <form>
    <div class="form-group" *ngIf="parentReminder">
      <label>Based on:</label>
      <div class="parent-reminder-info">
        <div><strong>Note:</strong> {{parentReminder.note}}</div>
        <div><strong>Company:</strong> {{parentReminder.companyID}} - {{parentReminder.companyName}}</div>
      </div>
    </div>
    
    <div class="form-group" *ngIf="isUnaffiliated">
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i> This reminder will not be associated with any company.
      </div>
    </div>
    
    <div class="form-group">
      <label for="reminderNote">Note <span class="text-danger">*</span></label>
      <textarea id="reminderNote" class="form-control" rows="3" [(ngModel)]="newReminderModel.note" name="note" required data-testid="new-reminder-modal-note"></textarea>
    </div>
    <div class="form-group">
      <label for="followUpDate">Follow-Up Date <span class="text-danger">*</span></label>
      <input type="date" id="followUpDate" class="form-control" 
             [ngModel]="newReminderModel.followUpDate | date:'yyyy-MM-dd'" 
             (ngModelChange)="newReminderModel.followUpDate = $event"
             name="followUpDate" required data-testid="new-reminder-modal-follow-up-date">
    </div>
    <div class="form-group">
      <label for="priority">Priority</label>
      <select id="priority" class="form-control" [(ngModel)]="newReminderModel.priority" name="priority" data-testid="new-reminder-modal-priority">
        <option *ngFor="let option of priorityOptions" [value]="option.value">{{option.label}}</option>
      </select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()" data-testid="new-reminder-modal-cancel">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="saveNewReminder()" [disabled]="!newReminderModel?.note || !newReminderModel?.followUpDate" data-testid="new-reminder-modal-save">Save</button>
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/reminders/new-reminder-modal/new-reminder-modal.component.html